
















































import {Component, Vue} from 'vue-property-decorator';
import SubscriptionPlanService from "@/services/SubscriptionPlanService";
import Workspaces from "@/state/Workspaces";
import SubscriptionService from "@/services/SubscriptionService";
import UserSubscriptionDetailsDTO from "@/dto/subscription/UserSubscriptionDetailsDTO";
import {processError} from "@/utils/ComponentUtils";
import PayPalPlanDTO from "@/dto/subscription/PayPalPlanDTO";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import ProfileService from "@/services/ProfileService";
import UserSummary from "@/dto/profile/UserSummary";
import SubscriptionsAdminModal from "@/components/profile/admin/SubscriptionsAdminModal.vue";
import {BillingAgreementStatus} from "@/constants/SubscriptionConstants";
import Clipboard from "@/state/Clipboard";

@Component({
  components: { SubscriptionsAdminModal }
})
export default class SubscriptionsAdminView extends Vue {

  subscriptions: Array<UserSubscriptionDetailsDTO> = []
  planGroups: Array<{ group: PortalDictionaryDTO; plans: Array<PayPalPlanDTO> }> = []
  userSummary: UserSummary | null = null

  showCreateModal = false

  // expose enum to template
  public BillingAgreementStatus = BillingAgreementStatus

  copyApproveLink(link: string) {
    if (!link) return;
    Clipboard.write(link);
  }

  async mounted() {
    await this.loadSubscriptions();
    await this.loadPlans();
    await this.loadProfiles();
  }

  async loadSubscriptions() {
    this.$loadOn();
    await SubscriptionService.getUserSubscriptions(this.userId).then(
        ok => {
          this.subscriptions = ok.data
          this.$loadOff();
        },
        error => processError(this, error)
    )
  }

  async loadPlans() {
    this.$loadOn();
    try {
      const groups = (await SubscriptionPlanService.getUserActivePayPalGroups(this.userId)).data
      this.planGroups = await Promise.all(
          groups.map(async (g) => {
            const plans = (await SubscriptionPlanService.getActivePayPalPlans(g.name)).data
            return {group: g, plans}
          })
      )
    } catch (e) {
      processError(this, e)
    }
    this.$loadOff();
  }

  async loadProfiles() {
    try {
      const resp = await ProfileService.getUserSummary(this.userId)
      this.userSummary = resp.data
    } catch (e) {
      processError(this, e)
    }
  }

  async onModalCreated(link: string) {
    // refresh subscriptions and keep modal open to show link inside it; close after refresh
    await this.loadSubscriptions()
    this.showCreateModal = true // keep open; parent just acknowledges
  }

  get userId(): number {
    return Workspaces.getCurrent.userId;
  }
}
